var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#f5f5f5;}.cls-3{fill:#5e6175;}.cls-4{fill:#e1830e;}.cls-5{fill:#a9afc4;}.cls-6{fill:#dee1ec;}.cls-7,.cls-8{mix-blend-mode:multiply;}.cls-7{fill:url(#linear-gradient);}.cls-8{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 204.82,
    y1: 238.51,
    x2: 204.82,
    y2: 346.92,
    gradientTransform: "matrix(-1, 0, 0, 1, 488.51, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cacfdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef0f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 147.9,
    y1: 244.7,
    x2: 265.51,
    y2: 244.7,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Distress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Distress"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.3,335.74l25.45-7.88-7.88,25.44a58,58,0,1,1-17.57-17.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.87,427.74a61,61,0,0,1,74.86-95.27l29.57-9.16-9.16,29.57a61,61,0,0,1-95.27,74.86Zm4.24-82.05a55,55,0,1,0,85.23,9.23l-.75-1.17,6.61-21.34L124.86,339l-1.18-.76A55.32,55.32,0,0,0,55.11,345.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "84.44 348.52 84.44 373.46 88.25 395.25 100.02 395.25 103.9 373.46 103.9 348.52 84.44 348.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 86.35,
    y: 405.05,
    width: 15.64,
    height: 15.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.5,249c-.77-4.44-.89-5.1-1-6l5.94-.89c.1.71.14.9,1,5.84Zm4.35-16.29-6-.21a57.8,57.8,0,0,1,.56-6.3l5.94.86A53.17,53.17,0,0,0,58.85,232.72Zm2.72-14.81L55.9,216a58.35,58.35,0,0,1,2.37-5.86l5.43,2.56A51,51,0,0,0,61.57,217.91Zm6.92-13.38L63.62,201c.36-.5.23-.32,3.64-4.85l4.79,3.61C68.54,204.45,68.83,204.06,68.49,204.53Zm9.57-12.74-4.79-3.61,3.6-4.8,4.8,3.61ZM87.68,179l-4.8-3.61,3.61-4.79,4.79,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M368.92,85.1l-7.84-18.31L353.23,85.1a15.07,15.07,0,0,0-.58,3.06,8.42,8.42,0,1,0,16.27-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M361.07,99.58a11.41,11.41,0,0,1-10.6-15.66l10.61-24.75L371.71,84A11.44,11.44,0,0,1,361.07,99.58Zm-5-13.48a11.67,11.67,0,0,0-.41,2.06,5.42,5.42,0,1,0,10.49-1.93l-5.06-11.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M410.12,72.54,399.76,48.35l-10.38,24.2a19.73,19.73,0,0,0-.77,4,11.14,11.14,0,1,0,21.51-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M399.74,90.72c-9.29,0-16.83-9-13.12-19.36l13.14-30.63,13.15,30.72A14.15,14.15,0,0,1,399.74,90.72Zm-7.53-17.17a16,16,0,0,0-.6,3,8.14,8.14,0,1,0,15.73-2.92L399.75,56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M388.19,115.33l-5.66-13.22-5.67,13.22a10.86,10.86,0,0,0-.42,2.21,6.08,6.08,0,1,0,11.75-2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.52,126.62a9.06,9.06,0,0,1-8.41-12.47l8.43-19.66L391,114.24A9.1,9.1,0,0,1,382.52,126.62Zm-2.82-10.29a8.32,8.32,0,0,0-.26,1.23,3.08,3.08,0,1,0,6-1.1l-2.88-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177.8,117.47l15.48-29.39a41.3,41.3,0,0,1,16.58-16.84l33.28-18.32a9.28,9.28,0,0,1,12,3.73,9.11,9.11,0,0,1-2.78,12.12L227.59,85.56A8.47,8.47,0,0,0,224,91.32l-2.45,16.77a27.73,27.73,0,0,1-3.53,10l-2.27,3.72a19.14,19.14,0,0,1-6.3,6.48l-9,5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200.25,137.61l-26.31-19.25,16.69-31.67a44.11,44.11,0,0,1,17.78-18.08l33.44-18.4a12.33,12.33,0,0,1,15.91,4.94,12.17,12.17,0,0,1-3.7,16.1l-24.78,16.8a5.4,5.4,0,0,0-2.34,3.71l-2.45,16.77a30.52,30.52,0,0,1-3.92,11.1C214.58,129.47,215.54,128,200.25,137.61Zm-18.58-21,18.84,13.79c11.11-7,10-5.68,14.91-13.81a24.29,24.29,0,0,0,3.13-8.89L221,90.89a11.5,11.5,0,0,1,4.91-7.81l24.78-16.8a6.14,6.14,0,0,0,1.87-8.13,6.31,6.31,0,0,0-8.05-2.56l-33.2,18.28a38,38,0,0,0-15.37,15.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.34,463.65V316.59l-73.78-43.44c-24.64-12.47-29.86-43-14.24-63.26l63-76.17,36.84,26-39.28,57.74,78.6,18,8.77-4.06a9.39,9.39,0,0,1,3.4-.62h82a11.16,11.16,0,0,1,4.56,1.1l54.72,22.36a76.81,76.81,0,0,1,29.52,21.42c.1.12,57.21,96,57.14,95.87a38.72,38.72,0,0,1,.2,39.28L440,463.65H387.08v-5.8l35.16-62.43-35.16-53.86V463.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.58,261.36l31,25.82L336.92,235l-7.75-3a12.2,12.2,0,0,0-4.5-1.1h-5.93Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "214.73 241.67 245.94 314.68 283.58 283.35 321.2 314.68 352.65 241.14 336.92 234.95 314.59 287.18 283.58 261.37 252.56 287.18 230.46 235.48 214.73 241.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.46,235.48l22.1,51.7,31-25.82-35.17-30.55c-6,0-7.14-.19-9.18.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.76,292.06,279,261.41l38.67-33.6h7.21a15.31,15.31,0,0,1,5.51,1.33l10.55,4.15Zm-27.55-30.75,25.2,21,19.53-45.68c-8.34-3.29-6.06-2.8-13.08-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M251.39,292.06,226.56,234l11.58-5.35c2.64-1,3.84-.82,11.39-.82l38.68,33.6Zm-17-55.08,19.37,45.32,25.21-21-31.66-27.5c-5,0-5.56-.12-6.89.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 176.34,
    y: 297.91,
    width: 6,
    height: 18.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "191.14 159.75 207.87 137.07 171.43 112.1 154.3 133.72 191.14 159.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M191.81,163.9,150,134.34,170.81,108l41.31,28.31Zm-33.19-30.8,31.85,22.51,13.14-17.82L172,116.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M223,233.14a84.81,84.81,0,0,0,117.61,3.43l-11.44-4.67a11.33,11.33,0,0,0-4.57-1.1h-82a9.39,9.39,0,0,0-3.4.62l-8.77,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M390.08,463.65h-6V331.48l41.67,63.82-35.67,63.34Zm0-112v94.77l28.65-50.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M442.58,465.16l-5.18-3,30.75-52.82a35.69,35.69,0,0,0-.18-36.23l-57-95.66A74,74,0,0,0,382.76,257c-60.28-24.64-56.3-23.24-58.15-23.24-88.92,0-82.72-.17-84.21.39l-9.61,4.44-83.89-19.2L187,160.5l-32.16-22.73-61.21,74c-14.47,18.73-9.17,46.44,11.67,57.81,3.64,2-9.5-5.7,77,45.25V463.65h-6V318.3C93,269.21,106.25,277,102.42,274.89,78.53,261.84,72,230,88.94,208.06l64.82-78.4L195.28,159l-38.47,56.54,73.32,16.78,8-3.69a12.43,12.43,0,0,1,4.49-.83h82a14.23,14.23,0,0,1,5.75,1.34L385,251.48a80.18,80.18,0,0,1,30.67,22.26c.44.63-3.82-6.49,57.42,96.28a41.7,41.7,0,0,1,.22,42.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.58,238.3a62.22,62.22,0,0,0,62.22-62.22V144.86a62.22,62.22,0,0,0-124.44,0v31.22A62.22,62.22,0,0,0,283.58,238.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.58,241.3a65.3,65.3,0,0,1-65.22-65.22V144.86a65.22,65.22,0,0,1,130.44,0v31.22A65.3,65.3,0,0,1,283.58,241.3Zm0-155.65a59.28,59.28,0,0,0-59.22,59.21v31.22a59.22,59.22,0,0,0,118.44,0V144.86A59.28,59.28,0,0,0,283.58,85.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.87,158v8.76a13.21,13.21,0,0,0,3.87,9.35l4.22,4.22a13.12,13.12,0,0,0,5.52,3.3c-.19-3-.12-2.45-.12-38.86A13.23,13.23,0,0,0,207.87,158Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.68,183.6a13.12,13.12,0,0,0,5.43-3.27l4.21-4.22a13.17,13.17,0,0,0,3.87-9.35V158a13.22,13.22,0,0,0-13.39-13.23C345.8,182.67,345.85,180.86,345.68,183.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M224.75,187.74c-8.86-2.65-8.13-2.49-15.13-9.51a16.27,16.27,0,0,1-4.75-11.47V158a16.25,16.25,0,0,1,16.23-16.23h3.26C224.36,187,224.23,179.54,224.75,187.74Zm-6.39-39.6a10.26,10.26,0,0,0-7.49,9.86v8.76a10.21,10.21,0,0,0,3,7.22c4.52,4.53,4.28,4.3,4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.4,187.73c.53-8.08.4-.84.4-46H346A16.24,16.24,0,0,1,362.19,158v8.76a16.23,16.23,0,0,1-4.76,11.48C350.52,185.17,351.28,185,342.4,187.73Zm6.4-39.56v30.22c.16-.14.2-.19,4.4-4.4a10.21,10.21,0,0,0,3-7.23V158A10.23,10.23,0,0,0,348.8,148.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M283.58,79.14c-32.53-1.63-62.09,25.06-62.09,60v17.36a2.33,2.33,0,0,0,2.5,2.33c15.71-1.36,15.59-15.45,15.59-15.45,0-17.22,16.38-18.6,16.38-18.6h10.53a12.07,12.07,0,0,1,8.55,3.55,12,12,0,0,0,17.08,0,12.07,12.07,0,0,1,8.55-3.55H311.2s16.38,1.38,16.38,18.6c0,0-.12,14.09,15.59,15.45a2.33,2.33,0,0,0,2.5-2.33V139.16C345.67,104.23,316.14,77.51,283.58,79.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M345.68,139.16v17.36a2.34,2.34,0,0,1-2.51,2.33c-15.71-1.35-15.59-15.45-15.59-15.45,0-17.22-16.38-18.61-16.38-18.61H300.67a12.09,12.09,0,0,0-8.55,3.56,12,12,0,0,1-17.08,0,12.1,12.1,0,0,0-8.55-3.56H256s-16.38,1.39-16.38,18.61c0,0,.11,14.1-15.59,15.45a2.34,2.34,0,0,1-2.51-2.33V139.16a60,60,0,0,1,62-60h.16A60,60,0,0,1,345.68,139.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.49,156.52V139.16a62.92,62.92,0,0,1,65.09-63,62.92,62.92,0,0,1,65.09,63v17.36a5.33,5.33,0,0,1-5.76,5.32c-18.26-1.58-18.33-18.3-18.33-18.47,0-5.92-2.22-10.32-6.58-13.06a18.05,18.05,0,0,0-7-2.51H300.67a9.13,9.13,0,0,0-6.42,2.66,15,15,0,0,1-21.34,0,9.14,9.14,0,0,0-6.42-2.66H256.12a18.11,18.11,0,0,0-7,2.51c-4.37,2.74-6.58,7.14-6.58,13.09,0,.14-.07,16.86-18.34,18.44A5.33,5.33,0,0,1,218.49,156.52Zm82.18-34.72h10.78c6.61.55,19.13,5.78,19.13,21.59,0,1.14.38,11,12.09,12.38V139.16a56.94,56.94,0,0,0-58.9-57c-.14-3.9-.14-4.09,0,0a1.81,1.81,0,0,1-.33,0,56.93,56.93,0,0,0-58.92,57v16.62c12-1.46,12.09-11.9,12.09-12.36,0-15.83,12.51-21.06,19.13-21.61.36,0-.9,0,10.78,0a15.09,15.09,0,0,1,10.67,4.44,9,9,0,0,0,12.83,0A15.14,15.14,0,0,1,300.67,121.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "310.25 283.64 283.58 261.36 256.91 283.64 270.24 301.67 256.91 439.35 283.68 463.65 310.25 439.35 296.91 301.67 310.25 283.64"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistress);
export default __webpack_public_path__ + "static/media/Distress.a821d75184df6f7f564a3bf70e838a3e.svg";
export { ForwardRef as ReactComponent };